(window.webpackJsonp=window.webpackJsonp||[]).push([[5],{
/***/"+/1h":
/***/function(e,t,i){"use strict";
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-legacy.js?babel-target=es6
i("pYlh"),i("1Ohj"),i("zrEE"),i("LCON"),i("c7vL");
// EXTERNAL MODULE: ./node_modules/@polymer/iron-flex-layout/iron-flex-layout.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@polymer/paper-dialog-behavior/paper-dialog-shared-styles.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/*
### Styling

The following custom properties and mixins are available for styling.

Custom property | Description | Default
----------------|-------------|----------
`--paper-dialog-background-color` | Dialog background color | `--primary-background-color`
`--paper-dialog-color` | Dialog foreground color | `--primary-text-color`
`--paper-dialog` | Mixin applied to the dialog | `{}`
`--paper-dialog-title` | Mixin applied to the title (`<h2>`) element | `{}`
`--paper-dialog-button-color` | Button area foreground color | `--default-primary-color`
*/
const o=document.createElement("template");o.setAttribute("style","display: none;"),o.innerHTML='<dom-module id="paper-dialog-shared-styles"><template><style>:host { display: block; margin: 24px 40px; background: var(--paper-dialog-background-color, var(--primary-background-color)); color: var(--paper-dialog-color, var(--primary-text-color)); @apply --paper-font-body1; @apply --shadow-elevation-16dp; @apply --paper-dialog; } :host >::slotted(*) { margin-top: 20px; padding: 0 24px; } :host >::slotted(.no-padding) { padding: 0; } :host >::slotted(*:first-child) { margin-top: 24px; } :host >::slotted(*:last-child) { margin-bottom: 24px; } /* In 1.x, this selector was `:host > ::content h2`. In 2.x <slot> allows\n      to select direct children only, which increases the weight of this\n      selector, so we have to re-define first-child/last-child margins below. */\n      :host > ::slotted(h2) {\n        position: relative;\n        margin: 0;\n\n        @apply --paper-font-title;\n        @apply --paper-dialog-title;\n      }\n\n      /* Apply mixin again, in case it sets margin-top. */\n      :host > ::slotted(h2:first-child) {\n        margin-top: 24px;\n        @apply --paper-dialog-title;\n      }\n\n      /* Apply mixin again, in case it sets margin-bottom. */\n      :host > ::slotted(h2:last-child) {\n        margin-bottom: 24px;\n        @apply --paper-dialog-title;\n      }\n\n      :host > ::slotted(.paper-dialog-buttons),\n      :host > ::slotted(.buttons) {\n        position: relative;\n        padding: 8px 8px 8px 24px;\n        margin: 0;\n\n        color: var(--paper-dialog-button-color, var(--primary-color));\n\n        @apply --layout-horizontal;\n        @apply --layout-end-justified;\n      }\n    </style>\n  </template>\n</dom-module>',document.head.appendChild(o.content);
// CONCATENATED MODULE: ./node_modules/@polymer/neon-animation/neon-animatable-behavior.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * `NeonAnimatableBehavior` is implemented by elements containing
 * animations for use with elements implementing
 * `NeonAnimationRunnerBehavior`.
 * @polymerBehavior
 */
const n=[{properties:{
/**
     * Animation configuration. See README for more info.
     */
animationConfig:{type:Object},
/**
     * Convenience property for setting an 'entry' animation. Do not set
     * `animationConfig.entry` manually if using this. The animated node is set
     * to `this` if using this property.
     */
entryAnimation:{observer:"_entryAnimationChanged",type:String},
/**
     * Convenience property for setting an 'exit' animation. Do not set
     * `animationConfig.exit` manually if using this. The animated node is set
     * to `this` if using this property.
     */
exitAnimation:{observer:"_exitAnimationChanged",type:String}},_entryAnimationChanged:function(){this.animationConfig=this.animationConfig||{},this.animationConfig.entry=[{name:this.entryAnimation,node:this}]},_exitAnimationChanged:function(){this.animationConfig=this.animationConfig||{},this.animationConfig.exit=[{name:this.exitAnimation,node:this}]},_copyProperties:function(e,t){
// shallowly copy properties from config2 to config1
for(var i in t)e[i]=t[i]},_cloneConfig:function(e){var t={isClone:!0};return this._copyProperties(t,e),t},_getAnimationConfigRecursive:function(e,t,i){// type is optional
var o;if(this.animationConfig)if(this.animationConfig.value&&"function"==typeof this.animationConfig.value)this._warn(this._logf("playAnimation","Please put 'animationConfig' inside of your components 'properties' object instead of outside of it."));else// iterate animations and recurse to process configurations from child nodes
if(o=e?this.animationConfig[e]:this.animationConfig,Array.isArray(o)||(o=[o]),o)for(var n,a=0;n=o[a];a++)if(n.animatable)n.animatable._getAnimationConfigRecursive(n.type||e,t,i);else if(n.id){var s=t[n.id];s?(
// merge configurations with the same id, making a clone lazily
s.isClone||(t[n.id]=this._cloneConfig(s),s=t[n.id]),this._copyProperties(s,n)):
// put any configs with an id into a map
t[n.id]=n}else i.push(n)},
/**
   * An element implementing `NeonAnimationRunnerBehavior` calls this
   * method to configure an animation with an optional type. Elements
   * implementing `NeonAnimatableBehavior` should define the property
   * `animationConfig`, which is either a configuration object or a map of
   * animation type to array of configuration objects.
   */
getAnimationConfig:function(e){var t={},i=[];// append the configurations saved in the map to the array
for(var o in this._getAnimationConfigRecursive(e,t,i),t)i.push(t[o]);return i}},{_configureAnimations:function(e){var t=[],i=[];if(e.length>0)for(let t,o=0;t=e[o];o++){let e=document.createElement(t.name);// is this element actually a neon animation?
if(e.isNeonAnimation){let o=null;// Closure compiler does not work well with a try / catch here.
// .configure needs to be explicitly defined
e.configure||(
/**
             * @param {Object} config
             * @return {AnimationEffectReadOnly}
             */
e.configure=function(e){return null}),o=e.configure(t),i.push({result:o,config:t,neonAnimation:e})}else console.warn(this.is+":",t.name,"not found!")}for(var o=0;o<i.length;o++){let e=i[o].result,n=i[o].config,a=i[o].neonAnimation;// configuration or play could fail if polyfills aren't loaded
try{
// Check if we have an Effect rather than an Animation
"function"!=typeof e.cancel&&(e=document.timeline.play(e))}catch(t){e=null,console.warn("Couldnt play","(",n.name,").",t)}e&&t.push({neonAnimation:a,config:n,animation:e})}return t},_shouldComplete:function(e){for(var t=!0,i=0;i<e.length;i++)if("finished"!=e[i].animation.playState){t=!1;break}return t},_complete:function(e){for(var t=0;t<e.length;t++)e[t].neonAnimation.complete(e[t].config);for(t=0;t<e.length;t++)e[t].animation.cancel()},
/**
   * Plays an animation with an optional `type`.
   * @param {string=} type
   * @param {!Object=} cookie
   */
playAnimation:function(e,t){var i=this.getAnimationConfig(e);if(i){this._active=this._active||{},this._active[e]&&(this._complete(this._active[e]),delete this._active[e]);var o=this._configureAnimations(i);if(0!=o.length){this._active[e]=o;for(var n=0;n<o.length;n++)o[n].animation.onfinish=function(){this._shouldComplete(o)&&(this._complete(o),delete this._active[e],this.fire("neon-animation-finish",t,{bubbles:!1}))}.bind(this)}else this.fire("neon-animation-finish",t,{bubbles:!1})}},
/**
   * Cancels the currently running animations.
   */
cancelAnimation:function(){for(var e in this._active){var t=this._active[e];for(var i in t)t[i].animation.cancel()}this._active={}}}];
// CONCATENATED MODULE: ./node_modules/@polymer/neon-animation/neon-animation-runner-behavior.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * `NeonAnimationRunnerBehavior` adds a method to run animations.
 *
 * @polymerBehavior NeonAnimationRunnerBehavior
 */
// EXTERNAL MODULE: ./node_modules/@polymer/iron-fit-behavior/iron-fit-behavior.js?babel-target=es6
var a=i("wLOY"),s=i("JxY1"),r=i("hvZu"),l=i("H/aU"),c=Element.prototype,h=c.matches||c.matchesSelector||c.mozMatchesSelector||c.msMatchesSelector||c.oMatchesSelector||c.webkitMatchesSelector;
// EXTERNAL MODULE: ./node_modules/@polymer/iron-resizable-behavior/iron-resizable-behavior.js?babel-target=es6
const d=new class{
/**
   * Returns a sorted array of tabbable nodes, including the root node.
   * It searches the tabbable nodes in the light and shadow dom of the chidren,
   * sorting the result by tabindex.
   * @param {!Node} node
   * @return {!Array<!HTMLElement>}
   */
getTabbableNodes(e){var t=[];// If there is at least one element with tabindex > 0, we need to sort
// the final array by tabindex.
return this._collectTabbableNodes(e,t)?this._sortByTabIndex(t):t}
/**
   * Returns if a element is focusable.
   * @param {!HTMLElement} element
   * @return {boolean}
   */isFocusable(e){
// From http://stackoverflow.com/a/1600194/4228703:
// There isn't a definite list, it's up to the browser. The only
// standard we have is DOM Level 2 HTML
// https://www.w3.org/TR/DOM-Level-2-HTML/html.html, according to which the
// only elements that have a focus() method are HTMLInputElement,
// HTMLSelectElement, HTMLTextAreaElement and HTMLAnchorElement. This
// notably omits HTMLButtonElement and HTMLAreaElement. Referring to these
// tests with tabbables in different browsers
// http://allyjs.io/data-tables/focusable.html
// Elements that cannot be focused if they have [disabled] attribute.
return h.call(e,"input, select, textarea, button, object")?h.call(e,":not([disabled])"):h.call(e,"a[href], area[href], iframe, [tabindex], [contentEditable]");// Elements that can be focused even if they have [disabled] attribute.
}
/**
   * Returns if a element is tabbable. To be tabbable, a element must be
   * focusable, visible, and with a tabindex !== -1.
   * @param {!HTMLElement} element
   * @return {boolean}
   */isTabbable(e){return this.isFocusable(e)&&h.call(e,':not([tabindex="-1"])')&&this._isVisible(e)}
/**
   * Returns the normalized element tabindex. If not focusable, returns -1.
   * It checks for the attribute "tabindex" instead of the element property
   * `tabIndex` since browsers assign different values to it.
   * e.g. in Firefox `<div contenteditable>` has `tabIndex = -1`
   * @param {!HTMLElement} element
   * @return {!number}
   * @private
   */_normalizedTabIndex(e){if(this.isFocusable(e)){var t=e.getAttribute("tabindex")||0;return Number(t)}return-1}
/**
   * Searches for nodes that are tabbable and adds them to the `result` array.
   * Returns if the `result` array needs to be sorted by tabindex.
   * @param {!Node} node The starting point for the search; added to `result`
   * if tabbable.
   * @param {!Array<!HTMLElement>} result
   * @return {boolean}
   * @private
   */_collectTabbableNodes(e,t){
// If not an element or not visible, no need to explore children.
if(e.nodeType!==Node.ELEMENT_NODE)return!1;var i=
/** @type {!HTMLElement} */
e;if(!this._isVisible(i))return!1;var o,n=this._normalizedTabIndex(i),a=n>0;n>=0&&t.push(i),o="content"===i.localName||"slot"===i.localName?Object(r.a)(i).getDistributedNodes():Object(r.a)(i.root||i).children;// In ShadowDOM v1, tab order is affected by the order of distrubution.
// E.g. getTabbableNodes(#root) in ShadowDOM v1 should return [#A, #B];
// in ShadowDOM v0 tab order is not affected by the distrubution order,
// in fact getTabbableNodes(#root) returns [#B, #A].
//  <div id="root">
//   <!-- shadow -->
//     <slot name="a">
//     <slot name="b">
//   <!-- /shadow -->
//   <input id="A" slot="a">
//   <input id="B" slot="b" tabindex="1">
//  </div>
// TODO(valdrin) support ShadowDOM v1 when upgrading to Polymer v2.0.
for(var s=0;s<o.length;s++)
// Ensure method is always invoked to collect tabbable children.
a=this._collectTabbableNodes(o[s],t)||a;return a}
/**
   * Returns false if the element has `visibility: hidden` or `display: none`
   * @param {!HTMLElement} element
   * @return {boolean}
   * @private
   */_isVisible(e){
// Check inline style first to save a re-flow. If looks good, check also
// computed style.
var t=e.style;return"hidden"!==t.visibility&&"none"!==t.display&&("hidden"!==(t=window.getComputedStyle(e)).visibility&&"none"!==t.display)}
/**
   * Sorts an array of tabbable elements by tabindex. Returns a new array.
   * @param {!Array<!HTMLElement>} tabbables
   * @return {!Array<!HTMLElement>}
   * @private
   */_sortByTabIndex(e){
// Implement a merge sort as Array.prototype.sort does a non-stable sort
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
var t=e.length;if(t<2)return e;var i=Math.ceil(t/2),o=this._sortByTabIndex(e.slice(0,i)),n=this._sortByTabIndex(e.slice(i));return this._mergeSortByTabIndex(o,n)}
/**
   * Merge sort iterator, merges the two arrays into one, sorted by tab index.
   * @param {!Array<!HTMLElement>} left
   * @param {!Array<!HTMLElement>} right
   * @return {!Array<!HTMLElement>}
   * @private
   */_mergeSortByTabIndex(e,t){for(var i=[];e.length>0&&t.length>0;)this._hasLowerTabOrder(e[0],t[0])?i.push(t.shift()):i.push(e.shift());return i.concat(e,t)}
/**
   * Returns if element `a` has lower tab order compared to element `b`
   * (both elements are assumed to be focusable and tabbable).
   * Elements with tabindex = 0 have lower tab order compared to elements
   * with tabindex > 0.
   * If both have same tabindex, it returns false.
   * @param {!HTMLElement} a
   * @param {!HTMLElement} b
   * @return {boolean}
   * @private
   */_hasLowerTabOrder(e,t){
// Normalize tabIndexes
// e.g. in Firefox `<div contenteditable>` has `tabIndex = -1`
var i=Math.max(e.tabIndex,0),o=Math.max(t.tabIndex,0);return 0===i||0===o?o>i:i>o}};
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/legacy/polymer-fn.js?babel-target=es6
var p=i("qEMp"),u=i("o5Wi");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/html-tag.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@polymer/iron-overlay-behavior/iron-overlay-backdrop.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/*
`iron-overlay-backdrop` is a backdrop used by `Polymer.IronOverlayBehavior`. It
should be a singleton.

### Styling

The following custom properties and mixins are available for styling.

Custom property | Description | Default
-------------------------------------------|------------------------|---------
`--iron-overlay-backdrop-background-color` | Backdrop background color | #000
`--iron-overlay-backdrop-opacity`          | Backdrop opacity | 0.6
`--iron-overlay-backdrop`                  | Mixin applied to `iron-overlay-backdrop`.                      | {}
`--iron-overlay-backdrop-opened`           | Mixin applied to `iron-overlay-backdrop` when it is displayed | {}
*/
Object(p.a)({
/** @override */
_template:u.a`<style>:host{position:fixed;top:0;left:0;width:100%;height:100%;background-color:var(--iron-overlay-backdrop-background-color,#000);opacity:0;transition:opacity .2s;pointer-events:none;@apply --iron-overlay-backdrop;}:host(.opened){opacity:var(--iron-overlay-backdrop-opacity,.6);pointer-events:auto;@apply --iron-overlay-backdrop-opened;}</style><slot></slot>`,is:"iron-overlay-backdrop",properties:{
/**
     * Returns true if the backdrop is opened.
     */
opened:{reflectToAttribute:!0,type:Boolean,value:!1,observer:"_openedChanged"}},listeners:{transitionend:"_onTransitionend"},
/** @override */
created:function(){
// Used to cancel previous requestAnimationFrame calls when opened changes.
this.__openedRaf=null},
/** @override */
attached:function(){this.opened&&this._openedChanged(this.opened)},
/**
   * Appends the backdrop to document body if needed.
   */
prepare:function(){this.opened&&!this.parentNode&&Object(r.a)(document.body).appendChild(this)},
/**
   * Shows the backdrop.
   */
open:function(){this.opened=!0},
/**
   * Hides the backdrop.
   */
close:function(){this.opened=!1},
/**
   * Removes the backdrop from document body if needed.
   */
complete:function(){this.opened||this.parentNode!==document.body||Object(r.a)(this.parentNode).removeChild(this)},_onTransitionend:function(e){e&&e.target===this&&this.complete()},
/**
   * @param {boolean} opened
   * @private
   */
_openedChanged:function(e){if(e)
// Auto-attach.
this.prepare();else{
// Animation might be disabled via the mixin or opacity custom property.
// If it is disabled in other ways, it's up to the user to call complete.
var t=window.getComputedStyle(this);"0s"!==t.transitionDuration&&0!=t.opacity||this.complete()}this.isAttached&&(// Always cancel previous requestAnimationFrame.
this.__openedRaf&&(window.cancelAnimationFrame(this.__openedRaf),this.__openedRaf=null),// Force relayout to ensure proper transitions.
this.scrollTop=this.scrollTop,this.__openedRaf=window.requestAnimationFrame(function(){this.__openedRaf=null,this.toggleClass("opened",this.opened)}.bind(this)))}});
// EXTERNAL MODULE: ./node_modules/@polymer/iron-a11y-keys-behavior/iron-a11y-keys-behavior.js?babel-target=es6
var _=i("78gc"),f=i("hLn4");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/gestures.js?babel-target=es6
const b=new
// CONCATENATED MODULE: ./node_modules/@polymer/iron-overlay-behavior/iron-overlay-manager.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * @package
 */
class{constructor(){
/**
     * Used to keep track of the opened overlays.
     * @private {!Array<!Element>}
     */
this._overlays=[],
/**
     * iframes have a default z-index of 100,
     * so this default should be at least that.
     * @private {number}
     */
this._minimumZ=101,
/**
     * Memoized backdrop element.
     * @private {Element|null}
     */
this._backdropElement=null,// Enable document-wide tap recognizer.
// NOTE: Use useCapture=true to avoid accidentally prevention of the closing
// of an overlay via event.stopPropagation(). The only way to prevent
// closing of an overlay should be through its APIs.
// NOTE: enable tap on <html> to workaround Polymer/polymer#4459
// Pass no-op function because MSEdge 15 doesn't handle null as 2nd argument
// https://github.com/Microsoft/ChakraCore/issues/3863
f.a(document.documentElement,"tap",(function(){})),document.addEventListener("tap",this._onCaptureClick.bind(this),!0),document.addEventListener("focus",this._onCaptureFocus.bind(this),!0),document.addEventListener("keydown",this._onCaptureKeyDown.bind(this),!0)}
/**
   * The shared backdrop element.
   * @return {!Element} backdropElement
   */get backdropElement(){return this._backdropElement||(this._backdropElement=document.createElement("iron-overlay-backdrop")),this._backdropElement}
/**
   * The deepest active element.
   * @return {!Element} activeElement the active element
   */get deepActiveElement(){var e=document.activeElement;// document.activeElement can be null
// https://developer.mozilla.org/en-US/docs/Web/API/Document/activeElement
// In IE 11, it can also be an object when operating in iframes.
// In these cases, default it to document.body.
for(e&&e instanceof Element!=!1||(e=document.body);e.root&&Object(r.a)(e.root).activeElement;)e=Object(r.a)(e.root).activeElement;return e}
/**
   * Brings the overlay at the specified index to the front.
   * @param {number} i
   * @private
   */_bringOverlayAtIndexToFront(e){var t=this._overlays[e];if(t){var i=this._overlays.length-1,o=this._overlays[i];// If already the top element, return.
if(// Ensure always-on-top overlay stays on top.
o&&this._shouldBeBehindOverlay(t,o)&&i--,!(e>=i)){// Update z-index to be on top.
var n=Math.max(this.currentOverlayZ(),this._minimumZ);// Shift other overlays behind the new on top.
for(this._getZ(t)<=n&&this._applyOverlayZ(t,n);e<i;)this._overlays[e]=this._overlays[e+1],e++;this._overlays[i]=t}}}
/**
   * Adds the overlay and updates its z-index if it's opened, or removes it if
   * it's closed. Also updates the backdrop z-index.
   * @param {!Element} overlay
   */addOrRemoveOverlay(e){e.opened?this.addOverlay(e):this.removeOverlay(e)}
/**
   * Tracks overlays for z-index and focus management.
   * Ensures the last added overlay with always-on-top remains on top.
   * @param {!Element} overlay
   */addOverlay(e){var t=this._overlays.indexOf(e);if(t>=0)return this._bringOverlayAtIndexToFront(t),void this.trackBackdrop();var i=this._overlays.length,o=this._overlays[i-1],n=Math.max(this._getZ(o),this._minimumZ),a=this._getZ(e);// Ensure always-on-top overlay stays on top.
if(o&&this._shouldBeBehindOverlay(e,o)){
// This bumps the z-index of +2.
this._applyOverlayZ(o,n),i--;// Update minimumZ to match previous overlay's z-index.
var s=this._overlays[i-1];n=Math.max(this._getZ(s),this._minimumZ)}// Update z-index and insert overlay.
a<=n&&this._applyOverlayZ(e,n),this._overlays.splice(i,0,e),this.trackBackdrop()}
/**
   * @param {!Element} overlay
   */removeOverlay(e){var t=this._overlays.indexOf(e);-1!==t&&(this._overlays.splice(t,1),this.trackBackdrop())}
/**
   * Returns the current overlay.
   * @return {!Element|undefined}
   */currentOverlay(){var e=this._overlays.length-1;return this._overlays[e]}
/**
   * Returns the current overlay z-index.
   * @return {number}
   */currentOverlayZ(){return this._getZ(this.currentOverlay())}
/**
   * Ensures that the minimum z-index of new overlays is at least `minimumZ`.
   * This does not effect the z-index of any existing overlays.
   * @param {number} minimumZ
   */ensureMinimumZ(e){this._minimumZ=Math.max(this._minimumZ,e)}focusOverlay(){var e=
/** @type {?} */
this.currentOverlay();e&&e._applyFocus()}
/**
   * Updates the backdrop z-index.
   */trackBackdrop(){var e=this._overlayWithBackdrop();// Avoid creating the backdrop if there is no overlay with backdrop.
(e||this._backdropElement)&&(this.backdropElement.style.zIndex=this._getZ(e)-1,this.backdropElement.opened=!!e,// Property observers are not fired until element is attached
// in Polymer 2.x, so we ensure element is attached if needed.
// https://github.com/Polymer/polymer/issues/4526
this.backdropElement.prepare())}
/**
   * @return {!Array<!Element>}
   */getBackdrops(){for(var e=[],t=0;t<this._overlays.length;t++)this._overlays[t].withBackdrop&&e.push(this._overlays[t]);return e}
/**
   * Returns the z-index for the backdrop.
   * @return {number}
   */backdropZ(){return this._getZ(this._overlayWithBackdrop())-1}
/**
   * Returns the top opened overlay that has a backdrop.
   * @return {!Element|undefined}
   * @private
   */_overlayWithBackdrop(){for(var e=this._overlays.length-1;e>=0;e--)if(this._overlays[e].withBackdrop)return this._overlays[e]}
/**
   * Calculates the minimum z-index for the overlay.
   * @param {Element=} overlay
   * @private
   */_getZ(e){var t=this._minimumZ;if(e){var i=Number(e.style.zIndex||window.getComputedStyle(e).zIndex);// Check if is a number
// Number.isNaN not supported in IE 10+
i==i&&(t=i)}return t}
/**
   * @param {!Element} element
   * @param {number|string} z
   * @private
   */_setZ(e,t){e.style.zIndex=t}
/**
   * @param {!Element} overlay
   * @param {number} aboveZ
   * @private
   */_applyOverlayZ(e,t){this._setZ(e,t+2)}
/**
   * Returns the deepest overlay in the path.
   * @param {!Array<!Element>=} path
   * @return {!Element|undefined}
   * @suppress {missingProperties}
   * @private
   */_overlayInPath(e){e=e||[];for(var t=0;t<e.length;t++)if(e[t]._manager===this)return e[t]}
/**
   * Ensures the click event is delegated to the right overlay.
   * @param {!Event} event
   * @private
   */_onCaptureClick(e){var t=this._overlays.length-1;if(-1!==t)// Check if clicked outside of overlay.
for(var i,o=
/** @type {!Array<!EventTarget>} */
Object(r.a)(e).path;(i=
/** @type {?} */
this._overlays[t])&&this._overlayInPath(o)!==i&&(i._onCaptureClick(e),i.allowClickThrough);)t--}
/**
   * Ensures the focus event is delegated to the right overlay.
   * @param {!Event} event
   * @private
   */_onCaptureFocus(e){var t=
/** @type {?} */
this.currentOverlay();t&&t._onCaptureFocus(e)}
/**
   * Ensures TAB and ESC keyboard events are delegated to the right overlay.
   * @param {!Event} event
   * @private
   */_onCaptureKeyDown(e){var t=
/** @type {?} */
this.currentOverlay();t&&(_.a.keyboardEventMatchesKeys(e,"esc")?t._onCaptureEsc(e):_.a.keyboardEventMatchesKeys(e,"tab")&&t._onCaptureTab(e))}
/**
   * Returns if the overlay1 should be behind overlay2.
   * @param {!Element} overlay1
   * @param {!Element} overlay2
   * @return {boolean}
   * @suppress {missingProperties}
   * @private
   */_shouldBeBehindOverlay(e,t){return!e.alwaysOnTop&&t.alwaysOnTop}};
// CONCATENATED MODULE: ./node_modules/@polymer/iron-overlay-behavior/iron-scroll-manager.js?babel-target=es6
/**
@license
Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Used to calculate the scroll direction during touch events.
 * @type {!Object}
 */var v,m,g={pageX:0,pageY:0},y=null,k=[],x=[// Modern `wheel` event for mouse wheel scrolling:
"wheel",// Older, non-standard `mousewheel` event for some FF:
"mousewheel",// IE:
"DOMMouseScroll",// Touch enabled devices
"touchstart","touchmove"];
/**
 * Used to avoid computing event.path and filter scrollable nodes (better perf).
 * @type {?EventTarget}
 */
/**
 * Push an element onto the current scroll lock stack. The most recently
 * pushed element and its children will be considered scrollable. All
 * other elements will not be scrollable.
 *
 * Scroll locking is implemented as a stack so that cases such as
 * dropdowns within dropdowns are handled well.
 *
 * @param {!HTMLElement} element The element that should lock scroll.
 */
function C(e){
// Prevent pushing the same element twice
O.indexOf(e)>=0||(0===O.length&&
/**
 * @package
 */
function(){v=v||z.bind(void 0);for(var e=0,t=x.length;e<t;e++)
// NOTE: browsers that don't support objects as third arg will
// interpret it as boolean, hence useCapture = true in this case.
document.addEventListener(x[e],v,{capture:!0,passive:!1})}(),O.push(e),m=O[O.length-1],T=[],R=[])}
/**
 * Remove an element from the scroll lock stack. The element being
 * removed does not need to be the most recently pushed element. However,
 * the scroll lock constraints only change when the most recently pushed
 * element is removed.
 *
 * @param {!HTMLElement} element The element to remove from the scroll
 * lock stack.
 */function w(e){var t=O.indexOf(e);-1!==t&&(O.splice(t,1),m=O[O.length-1],T=[],R=[],0===O.length&&function(){for(var e=0,t=x.length;e<t;e++)
// NOTE: browsers that don't support objects as third arg will
// interpret it as boolean, hence useCapture = true in this case.
document.removeEventListener(x[e],v,{capture:!0,passive:!1})}
/**
 * Returns true if the event causes scroll outside the current locking
 * element, e.g. pointer/keyboard interactions, or scroll "leaking"
 * outside the locking element when it is already at its scroll boundaries.
 * @param {!Event} event
 * @return {boolean}
 * @package
 */())}const O=[];let T=null,R=null;function z(e){// If event has targetTouches (touch event), update last touch position.
if(
// Avoid canceling an event with cancelable=false, e.g. scrolling is in
// progress and cannot be interrupted.
e.cancelable&&function(e){
// Update if root target changed. For touch events, ensure we don't
// update during touchmove.
var t=Object(r.a)(e).rootTarget;"touchmove"!==e.type&&y!==t&&(y=t,k=
/**
 * Returns an array of scrollable nodes up to the current locking element,
 * which is included too if scrollable.
 * @param {!Array<!Node>} nodes
 * @return {!Array<!Node>} scrollables
 * @package
 */
function(e){// Loop from root target to locking element (included).
for(var t=[],i=e.indexOf(
/** @type {!Node} */
m),o=0;o<=i;o++)
// Skip non-Element nodes.
if(e[o].nodeType===Node.ELEMENT_NODE){var n=
/** @type {!Element} */
e[o],a=n.style;// Check inline style before checking computed style.
"scroll"!==a.overflow&&"auto"!==a.overflow&&(a=window.getComputedStyle(n)),"scroll"!==a.overflow&&"auto"!==a.overflow||t.push(n)}return t}
/**
 * Returns the node that is scrolling. If there is no scrolling,
 * returns undefined.
 * @param {!Array<!Node>} nodes
 * @param {number} deltaX Scroll delta on the x-axis
 * @param {number} deltaY Scroll delta on the y-axis
 * @return {!Node|undefined}
 * @package
 */(Object(r.a)(e).path));// Prevent event if no scrollable nodes.
if(!k.length)return!0;// Don't prevent touchstart event inside the locking element when it has
// scrollable nodes.
if("touchstart"===e.type)return!1;// Get deltaX/Y.
var i=
/**
 * Returns scroll `deltaX` and `deltaY`.
 * @param {!Event} event The scroll event
 * @return {{deltaX: number, deltaY: number}} Object containing the
 * x-axis scroll delta (positive: scroll right, negative: scroll left,
 * 0: no scroll), and the y-axis scroll delta (positive: scroll down,
 * negative: scroll up, 0: no scroll).
 * @package
 */
function(e){var t={deltaX:e.deltaX,deltaY:e.deltaY};// Already available.
if("deltaX"in e);else if("wheelDeltaX"in e&&"wheelDeltaY"in e)t.deltaX=-e.wheelDeltaX,t.deltaY=-e.wheelDeltaY;else if("wheelDelta"in e)t.deltaX=0,t.deltaY=-e.wheelDelta;else if("axis"in e)t.deltaX=1===e.axis?e.detail:0,t.deltaY=2===e.axis?e.detail:0;else if(e.targetTouches){var i=e.targetTouches[0];// Touch moves from right to left => scrolling goes right.
t.deltaX=g.pageX-i.pageX,// Touch moves from down to up => scrolling goes down.
t.deltaY=g.pageY-i.pageY}return t}
// CONCATENATED MODULE: ./node_modules/@polymer/iron-overlay-behavior/iron-overlay-behavior.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/** @polymerBehavior */(e);// Prevent if there is no child that can scroll.
return!function(e,t,i){
// No scroll.
if(!t&&!i)return;// Check only one axis according to where there is more scroll.
// Prefer vertical to horizontal.
for(var o=Math.abs(i)>=Math.abs(t),n=0;n<e.length;n++){var a=e[n];if(o?i<0?a.scrollTop>0:a.scrollTop<a.scrollHeight-a.clientHeight:t<0?a.scrollLeft>0:a.scrollLeft<a.scrollWidth-a.clientWidth)return a}}(k,i.deltaX,i.deltaY)}(e)&&e.preventDefault(),e.targetTouches){var t=e.targetTouches[0];g.pageX=t.pageX,g.pageY=t.pageY}}const A={properties:{
/**
     * True if the overlay is currently displayed.
     */
opened:{observer:"_openedChanged",type:Boolean,value:!1,notify:!0},
/**
     * True if the overlay was canceled when it was last closed.
     */
canceled:{observer:"_canceledChanged",readOnly:!0,type:Boolean,value:!1},
/**
     * Set to true to display a backdrop behind the overlay. It traps the focus
     * within the light DOM of the overlay.
     */
withBackdrop:{observer:"_withBackdropChanged",type:Boolean},
/**
     * Set to true to disable auto-focusing the overlay or child nodes with
     * the `autofocus` attribute` when the overlay is opened.
     */
noAutoFocus:{type:Boolean,value:!1},
/**
     * Set to true to disable canceling the overlay with the ESC key.
     */
noCancelOnEscKey:{type:Boolean,value:!1},
/**
     * Set to true to disable canceling the overlay by clicking outside it.
     */
noCancelOnOutsideClick:{type:Boolean,value:!1},
/**
     * Contains the reason(s) this overlay was last closed (see
     * `iron-overlay-closed`). `IronOverlayBehavior` provides the `canceled`
     * reason; implementers of the behavior can provide other reasons in
     * addition to `canceled`.
     */
closingReason:{
// was a getter before, but needs to be a property so other
// behaviors can override this.
type:Object},
/**
     * Set to true to enable restoring of focus when overlay is closed.
     */
restoreFocusOnClose:{type:Boolean,value:!1},
/**
     * Set to true to allow clicks to go through overlays.
     * When the user clicks outside this overlay, the click may
     * close the overlay below.
     */
allowClickThrough:{type:Boolean},
/**
     * Set to true to keep overlay always on top.
     */
alwaysOnTop:{type:Boolean},
/**
     * Determines which action to perform when scroll outside an opened overlay
     * happens. Possible values: lock - blocks scrolling from happening, refit -
     * computes the new position on the overlay cancel - causes the overlay to
     * close
     */
scrollAction:{type:String},
/**
     * Shortcut to access to the overlay manager.
     * @private
     * @type {!IronOverlayManagerClass}
     */
_manager:{type:Object,value:b},
/**
     * The node being focused.
     * @type {?Node}
     */
_focusedChild:{type:Object}},listeners:{"iron-resize":"_onIronResize"},observers:["__updateScrollObservers(isAttached, opened, scrollAction)"],
/**
   * The backdrop element.
   * @return {!Element}
   */
get backdropElement(){return this._manager.backdropElement},
/**
   * Returns the node to give focus to.
   * @return {!Node}
   */
get _focusNode(){return this._focusedChild||Object(r.a)(this).querySelector("[autofocus]")||this},
/**
   * Array of nodes that can receive focus (overlay included), ordered by
   * `tabindex`. This is used to retrieve which is the first and last focusable
   * nodes in order to wrap the focus for overlays `with-backdrop`.
   *
   * If you know what is your content (specifically the first and last focusable
   * children), you can override this method to return only `[firstFocusable,
   * lastFocusable];`
   * @return {!Array<!Node>}
   * @protected
   */
get _focusableNodes(){return d.getTabbableNodes(this)},
/**
   * @return {void}
   */
ready:function(){
// Used to skip calls to notifyResize and refit while the overlay is
// animating.
this.__isAnimating=!1,// with-backdrop needs tabindex to be set in order to trap the focus.
// If it is not set, IronOverlayBehavior will set it, and remove it if
// with-backdrop = false.
this.__shouldRemoveTabIndex=!1,// Used for wrapping the focus on TAB / Shift+TAB.
this.__firstFocusableNode=this.__lastFocusableNode=null,// Used by to keep track of the RAF callbacks.
this.__rafs={},// Focused node before overlay gets opened. Can be restored on close.
this.__restoreFocusNode=null,// Scroll info to be restored.
this.__scrollTop=this.__scrollLeft=null,this.__onCaptureScroll=this.__onCaptureScroll.bind(this),// Root nodes hosting the overlay, used to listen for scroll events on them.
this.__rootNodes=null,this._ensureSetup()},
/** @override */
attached:function(){
// Call _openedChanged here so that position can be computed correctly.
this.opened&&this._openedChanged(this.opened),this._observer=Object(r.a)(this).observeNodes(this._onNodesChange)},
/** @override */
detached:function(){for(var e in
// TODO(bicknellr): Per spec, checking `this._observer` should never be
// necessary because `connectedCallback` and `disconnectedCallback` should
// always be called in alternating order. However, the custom elements
// polyfill doesn't implement the reactions stack, so this can sometimes
// happen, particularly if ShadyDOM is in noPatch mode where the custom
// elements polyfill is installed before ShadyDOM. We should investigate
// whether or not we can either implement the reactions stack without major
// performance implications or patch ShadyDOM's functions to restore the
// typical ShadyDOM-then-custom-elements order and remove this workaround.
this._observer&&Object(r.a)(this).unobserveNodes(this._observer),this._observer=null,this.__rafs)null!==this.__rafs[e]&&cancelAnimationFrame(this.__rafs[e]);this.__rafs={},this._manager.removeOverlay(this),// We got detached while animating, ensure we show/hide the overlay
// and fire iron-overlay-opened/closed event!
this.__isAnimating&&(this.opened?this._finishRenderOpened():(
// Restore the focus if necessary.
this._applyFocus(),this._finishRenderClosed()))},
/**
   * Toggle the opened state of the overlay.
   */
toggle:function(){this._setCanceled(!1),this.opened=!this.opened},
/**
   * Open the overlay.
   */
open:function(){this._setCanceled(!1),this.opened=!0},
/**
   * Close the overlay.
   */
close:function(){this._setCanceled(!1),this.opened=!1},
/**
   * Cancels the overlay.
   * @param {Event=} event The original event
   */
cancel:function(e){this.fire("iron-overlay-canceled",e,{cancelable:!0}).defaultPrevented||(this._setCanceled(!0),this.opened=!1)},
/**
   * Invalidates the cached tabbable nodes. To be called when any of the
   * focusable content changes (e.g. a button is disabled).
   */
invalidateTabbables:function(){this.__firstFocusableNode=this.__lastFocusableNode=null},_ensureSetup:function(){this._overlaySetup||(this._overlaySetup=!0,this.style.outline="none",this.style.display="none")},
/**
   * Called when `opened` changes.
   * @param {boolean=} opened
   * @protected
   */
_openedChanged:function(e){e?this.removeAttribute("aria-hidden"):this.setAttribute("aria-hidden","true"),// Defer any animation-related code on attached
// (_openedChanged gets called again on attached).
this.isAttached&&(this.__isAnimating=!0,// Deraf for non-blocking rendering.
this.__deraf("__openedChanged",this.__openedChanged))},_canceledChanged:function(){this.closingReason=this.closingReason||{},this.closingReason.canceled=this.canceled},_withBackdropChanged:function(){
// If tabindex is already set, no need to override it.
this.withBackdrop&&!this.hasAttribute("tabindex")?(this.setAttribute("tabindex","-1"),this.__shouldRemoveTabIndex=!0):this.__shouldRemoveTabIndex&&(this.removeAttribute("tabindex"),this.__shouldRemoveTabIndex=!1),this.opened&&this.isAttached&&this._manager.trackBackdrop()},
/**
   * tasks which must occur before opening; e.g. making the element visible.
   * @protected
   */
_prepareRenderOpened:function(){
// Store focused node.
this.__restoreFocusNode=this._manager.deepActiveElement,// Needed to calculate the size of the overlay so that transitions on its
// size will have the correct starting points.
this._preparePositioning(),this.refit(),this._finishPositioning(),// Safari will apply the focus to the autofocus element when displayed
// for the first time, so we make sure to return the focus where it was.
this.noAutoFocus&&document.activeElement===this._focusNode&&(this._focusNode.blur(),this.__restoreFocusNode.focus())},
/**
   * Tasks which cause the overlay to actually open; typically play an
   * animation.
   * @protected
   */
_renderOpened:function(){this._finishRenderOpened()},
/**
   * Tasks which cause the overlay to actually close; typically play an
   * animation.
   * @protected
   */
_renderClosed:function(){this._finishRenderClosed()},
/**
   * Tasks to be performed at the end of open action. Will fire
   * `iron-overlay-opened`.
   * @protected
   */
_finishRenderOpened:function(){this.notifyResize(),this.__isAnimating=!1,this.fire("iron-overlay-opened")},
/**
   * Tasks to be performed at the end of close action. Will fire
   * `iron-overlay-closed`.
   * @protected
   */
_finishRenderClosed:function(){
// Hide the overlay.
this.style.display="none",// Reset z-index only at the end of the animation.
this.style.zIndex="",this.notifyResize(),this.__isAnimating=!1,this.fire("iron-overlay-closed",this.closingReason)},_preparePositioning:function(){this.style.transition=this.style.webkitTransition="none",this.style.transform=this.style.webkitTransform="none",this.style.display=""},_finishPositioning:function(){
// First, make it invisible & reactivate animations.
this.style.display="none",// Force reflow before re-enabling animations so that they don't start.
// Set scrollTop to itself so that Closure Compiler doesn't remove this.
this.scrollTop=this.scrollTop,this.style.transition=this.style.webkitTransition="",this.style.transform=this.style.webkitTransform="",// Now that animations are enabled, make it visible again
this.style.display="",// Force reflow, so that following animations are properly started.
// Set scrollTop to itself so that Closure Compiler doesn't remove this.
this.scrollTop=this.scrollTop},
/**
   * Applies focus according to the opened state.
   * @protected
   */
_applyFocus:function(){if(this.opened)this.noAutoFocus||this._focusNode.focus();else{
// Restore focus.
if(this.restoreFocusOnClose&&this.__restoreFocusNode){
// If the activeElement is `<body>` or inside the overlay,
// we are allowed to restore the focus. In all the other
// cases focus might have been moved elsewhere by another
// component or by an user interaction (e.g. click on a
// button outside the overlay).
var e=this._manager.deepActiveElement;(e===document.body||E(this,e))&&this.__restoreFocusNode.focus()}this.__restoreFocusNode=null,this._focusNode.blur(),this._focusedChild=null}},
/**
   * Cancels (closes) the overlay. Call when click happens outside the overlay.
   * @param {!Event} event
   * @protected
   */
_onCaptureClick:function(e){this.noCancelOnOutsideClick||this.cancel(e)},
/**
   * Keeps track of the focused child. If withBackdrop, traps focus within
   * overlay.
   * @param {!Event} event
   * @protected
   */
_onCaptureFocus:function(e){if(this.withBackdrop){var t=Object(r.a)(e).path;-1===t.indexOf(this)?(e.stopPropagation(),this._applyFocus()):this._focusedChild=
/** @type {Node} */
t[0]}},
/**
   * Handles the ESC key event and cancels (closes) the overlay.
   * @param {!Event} event
   * @protected
   */
_onCaptureEsc:function(e){this.noCancelOnEscKey||this.cancel(e)},
/**
   * Handles TAB key events to track focus changes.
   * Will wrap focus for overlays withBackdrop.
   * @param {!Event} event
   * @protected
   */
_onCaptureTab:function(e){if(this.withBackdrop){this.__ensureFirstLastFocusables();// TAB wraps from last to first focusable.
// Shift + TAB wraps from first to last focusable.
var t=e.shiftKey,i=t?this.__firstFocusableNode:this.__lastFocusableNode,o=t?this.__lastFocusableNode:this.__firstFocusableNode,n=!1;if(i===o)
// If nodeToCheck is the same as nodeToSet, it means we have an overlay
// with 0 or 1 focusables; in either case we still need to trap the
// focus within the overlay.
n=!0;else{
// In dom=shadow, the manager will receive focus changes on the main
// root but not the ones within other shadow roots, so we can't rely on
// _focusedChild, but we should check the deepest active element.
var a=this._manager.deepActiveElement;// If the active element is not the nodeToCheck but the overlay itself,
// it means the focus is about to go outside the overlay, hence we
// should prevent that (e.g. user opens the overlay and hit Shift+TAB).
n=a===i||a===this}n&&(
// When the overlay contains the last focusable element of the document
// and it's already focused, pressing TAB would move the focus outside
// the document (e.g. to the browser search bar). Similarly, when the
// overlay contains the first focusable element of the document and it's
// already focused, pressing Shift+TAB would move the focus outside the
// document (e.g. to the browser search bar).
// In both cases, we would not receive a focus event, but only a blur.
// In order to achieve focus wrapping, we prevent this TAB event and
// force the focus. This will also prevent the focus to temporarily move
// outside the overlay, which might cause scrolling.
e.preventDefault(),this._focusedChild=o,this._applyFocus())}},
/**
   * Refits if the overlay is opened and not animating.
   * @protected
   */
_onIronResize:function(){this.opened&&!this.__isAnimating&&this.__deraf("refit",this.refit)},
/**
   * Will call notifyResize if overlay is opened.
   * Can be overridden in order to avoid multiple observers on the same node.
   * @protected
   */
_onNodesChange:function(){this.opened&&!this.__isAnimating&&(
// It might have added focusable nodes, so invalidate cached values.
this.invalidateTabbables(),this.notifyResize())},
/**
   * Updates the references to the first and last focusable nodes.
   * @private
   */
__ensureFirstLastFocusables:function(){var e=this._focusableNodes;this.__firstFocusableNode=e[0],this.__lastFocusableNode=e[e.length-1]},
/**
   * Tasks executed when opened changes: prepare for the opening, move the
   * focus, update the manager, render opened/closed.
   * @private
   */
__openedChanged:function(){this.opened?(
// Make overlay visible, then add it to the manager.
this._prepareRenderOpened(),this._manager.addOverlay(this),// Move the focus to the child node with [autofocus].
this._applyFocus(),this._renderOpened()):(
// Remove overlay, then restore the focus before actually closing.
this._manager.removeOverlay(this),this._applyFocus(),this._renderClosed())},
/**
   * Debounces the execution of a callback to the next animation frame.
   * @param {!string} jobname
   * @param {!Function} callback Always bound to `this`
   * @private
   */
__deraf:function(e,t){var i=this.__rafs;null!==i[e]&&cancelAnimationFrame(i[e]),i[e]=requestAnimationFrame(function(){i[e]=null,t.call(this)}.bind(this))},
/**
   * @param {boolean} isAttached
   * @param {boolean} opened
   * @param {string=} scrollAction
   * @private
   */
__updateScrollObservers:function(e,t,i){e&&t&&this.__isValidScrollAction(i)?("lock"===i&&(this.__saveScrollPosition(),C(this)),this.__addScrollListeners()):(w(this),this.__removeScrollListeners())},
/**
   * @private
   */
__addScrollListeners:function(){if(!this.__rootNodes){// Listen for scroll events in all shadowRoots hosting this overlay only
// when in native ShadowDOM.
if(this.__rootNodes=[],l.s)for(var e=this;e;)e.nodeType===Node.DOCUMENT_FRAGMENT_NODE&&e.host&&this.__rootNodes.push(e),e=e.host||e.assignedSlot||e.parentNode;this.__rootNodes.push(document)}this.__rootNodes.forEach((function(e){e.addEventListener("scroll",this.__onCaptureScroll,{capture:!0,passive:!0})}),this)},
/**
   * @private
   */
__removeScrollListeners:function(){this.__rootNodes&&this.__rootNodes.forEach((function(e){e.removeEventListener("scroll",this.__onCaptureScroll,{capture:!0,passive:!0})}),this),this.isAttached||(this.__rootNodes=null)},
/**
   * @param {string=} scrollAction
   * @return {boolean}
   * @private
   */
__isValidScrollAction:function(e){return"lock"===e||"refit"===e||"cancel"===e},
/**
   * @private
   */
__onCaptureScroll:function(e){if(!(this.__isAnimating||Object(r.a)(e).path.indexOf(this)>=0))switch(this.scrollAction){case"lock":
// NOTE: scrolling might happen if a scroll event is not cancellable, or
// if user pressed keys that cause scrolling (they're not prevented in
// order not to break a11y features like navigate with arrow keys).
this.__restoreScrollPosition();break;case"refit":this.__deraf("refit",this.refit);break;case"cancel":this.cancel(e)}// Check if scroll outside the overlay.
},
/**
   * Memoizes the scroll position of the outside scrolling element.
   * @private
   */
__saveScrollPosition:function(){document.scrollingElement?(this.__scrollTop=document.scrollingElement.scrollTop,this.__scrollLeft=document.scrollingElement.scrollLeft):(
// Since we don't know if is the body or html, get max.
this.__scrollTop=Math.max(document.documentElement.scrollTop,document.body.scrollTop),this.__scrollLeft=Math.max(document.documentElement.scrollLeft,document.body.scrollLeft))},
/**
   * Resets the scroll position of the outside scrolling element.
   * @private
   */
__restoreScrollPosition:function(){document.scrollingElement?(document.scrollingElement.scrollTop=this.__scrollTop,document.scrollingElement.scrollLeft=this.__scrollLeft):(
// Since we don't know if is the body or html, set both.
document.documentElement.scrollTop=document.body.scrollTop=this.__scrollTop,document.documentElement.scrollLeft=document.body.scrollLeft=this.__scrollLeft)}},E=(e,t)=>{for(let o=t;o;o=(i=o).assignedSlot||i.parentNode||i.host)if(o===e)return!0;var i;return!1},N=[[a.a,s.a,A],{hostAttributes:{role:"dialog",tabindex:"-1"},properties:{
/**
     * If `modal` is true, this implies `no-cancel-on-outside-click`,
     * `no-cancel-on-esc-key` and `with-backdrop`.
     */
modal:{type:Boolean,value:!1},__readied:{type:Boolean,value:!1}},observers:["_modalChanged(modal, __readied)"],listeners:{tap:"_onDialogClick"},
/**
   * @return {void}
   */
ready:function(){
// Only now these properties can be read.
this.__prevNoCancelOnOutsideClick=this.noCancelOnOutsideClick,this.__prevNoCancelOnEscKey=this.noCancelOnEscKey,this.__prevWithBackdrop=this.withBackdrop,this.__readied=!0},_modalChanged:function(e,t){
// modal implies noCancelOnOutsideClick, noCancelOnEscKey and withBackdrop.
// We need to wait for the element to be ready before we can read the
// properties values.
t&&(e?(this.__prevNoCancelOnOutsideClick=this.noCancelOnOutsideClick,this.__prevNoCancelOnEscKey=this.noCancelOnEscKey,this.__prevWithBackdrop=this.withBackdrop,this.noCancelOnOutsideClick=!0,this.noCancelOnEscKey=!0,this.withBackdrop=!0):(
// If the value was changed to false, let it false.
this.noCancelOnOutsideClick=this.noCancelOnOutsideClick&&this.__prevNoCancelOnOutsideClick,this.noCancelOnEscKey=this.noCancelOnEscKey&&this.__prevNoCancelOnEscKey,this.withBackdrop=this.withBackdrop&&this.__prevWithBackdrop))},_updateClosingReasonConfirmed:function(e){this.closingReason=this.closingReason||{},this.closingReason.confirmed=e},
/**
   * Will dismiss the dialog if user clicked on an element with dialog-dismiss
   * or dialog-confirm attribute.
   */
_onDialogClick:function(e){for(
// Search for the element with dialog-confirm or dialog-dismiss,
// from the root target until this (excluded).
var t=Object(r.a)(e).path,i=0,o=t.indexOf(this);i<o;i++){var n=t[i];if(n.hasAttribute&&(n.hasAttribute("dialog-dismiss")||n.hasAttribute("dialog-confirm"))){this._updateClosingReasonConfirmed(n.hasAttribute("dialog-confirm")),this.close(),e.stopPropagation();break}}}}];
// CONCATENATED MODULE: ./node_modules/@polymer/paper-dialog/paper-dialog.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
Material design:
[Dialogs](https://www.google.com/design/spec/components/dialogs.html)

`<paper-dialog>` is a dialog with Material Design styling and optional
animations when it is opened or closed. It provides styles for a header, content
area, and an action area for buttons. You can use the
`<paper-dialog-scrollable>` element (in its own repository) if you need a
scrolling content area. To autofocus a specific child element after opening the
dialog, give it the `autofocus` attribute. See `Polymer.PaperDialogBehavior` and
`Polymer.IronOverlayBehavior` for specifics.

For example, the following code implements a dialog with a header, scrolling
content area and buttons. Focus will be given to the `dialog-confirm` button
when the dialog is opened.

    <paper-dialog>
      <h2>Header</h2>
      <paper-dialog-scrollable>
        Lorem ipsum...
      </paper-dialog-scrollable>
      <div class="buttons">
        <paper-button dialog-dismiss>Cancel</paper-button>
        <paper-button dialog-confirm autofocus>Accept</paper-button>
      </div>
    </paper-dialog>

### Styling

See the docs for `Polymer.PaperDialogBehavior` for the custom properties
available for styling this element.

### Animations

Set the `entry-animation` and/or `exit-animation` attributes to add an animation
when the dialog is opened or closed. See the documentation in
[PolymerElements/neon-animation](https://github.com/PolymerElements/neon-animation)
for more info.

For example:

    <script type="module">
      import '@polymer/neon-animation/animations/fade-out-animation.js';
      import '@polymer/neon-animation/animations/scale-up-animation.js';
    <\/script>

    <paper-dialog entry-animation="scale-up-animation"
                  exit-animation="fade-out-animation">
      <h2>Header</h2>
      <div>Dialog body</div>
    </paper-dialog>

### Accessibility

See the docs for `Polymer.PaperDialogBehavior` for accessibility features
implemented by this element.

@group Paper Elements
@element paper-dialog
@hero hero.svg
@demo demo/index.html
*/
Object(p.a)({_template:u.a`<style include="paper-dialog-shared-styles"></style><slot></slot>`,is:"paper-dialog",behaviors:[N,n],listeners:{"neon-animation-finish":"_onNeonAnimationFinish"},_renderOpened:function(){this.cancelAnimation(),this.playAnimation("entry")},_renderClosed:function(){this.cancelAnimation(),this.playAnimation("exit")},_onNeonAnimationFinish:function(){this.opened?this._finishRenderOpened():this._finishRenderClosed()}})},
/***/"/VC+":
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"b",(function(){return s})),
/* harmony export (binding) */i.d(t,"a",(function(){return r}));
/* harmony import */i("pYlh");
/* harmony import */var o=i("G2f5"),n=i("Z+yT"),a=i("n1r2");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * `PaperInkyFocusBehavior` implements a ripple when the element has keyboard
 * focus.
 *
 * @polymerBehavior PaperInkyFocusBehavior
 */
const s={observers:["_focusedChanged(receivedFocusFromKeyboard)"],_focusedChanged:function(e){e&&this.ensureRipple(),this.hasRipple()&&(this._ripple.holdDown=e)},_createRipple:function(){var e=a.a._createRipple();return e.id="ink",e.setAttribute("center",""),e.classList.add("circle"),e}},r=[o.a,n.a,a.a,s];
/** @polymerBehavior */},
/***/"23qz":
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return o}));
/* harmony import */i("pYlh");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * `iron-range-behavior` provides the behavior for something with a minimum to
 * maximum range.
 *
 * @demo demo/index.html
 * @polymerBehavior
 */const o={properties:{
/**
     * The number that represents the current value.
     */
value:{type:Number,value:0,notify:!0,reflectToAttribute:!0},
/**
     * The number that indicates the minimum value of the range.
     */
min:{type:Number,value:0,notify:!0},
/**
     * The number that indicates the maximum value of the range.
     */
max:{type:Number,value:100,notify:!0},
/**
     * Specifies the value granularity of the range's value.
     */
step:{type:Number,value:1,notify:!0},
/**
     * Returns the ratio of the value.
     */
ratio:{type:Number,value:0,readOnly:!0,notify:!0}},observers:["_update(value, min, max, step)"],_calcRatio:function(e){return(this._clampValue(e)-this.min)/(this.max-this.min)},_clampValue:function(e){return Math.min(this.max,Math.max(this.min,this._calcStep(e)))},_calcStep:function(e){if(
// polymer/issues/2493
e=parseFloat(e),!this.step)return e;var t=Math.round((e-this.min)/this.step);return this.step<1?t/(1/this.step)+this.min:t*this.step+this.min},_validateValue:function(){var e=this._clampValue(this.value);return this.value=this.oldValue=isNaN(e)?this.oldValue:e,this.value!==e},_update:function(){this._validateValue(),this._setRatio(100*this._calcRatio(this.value))}};
/***/},
/***/BQ7F:
/***/function(e,t,i){"use strict";
/* unused harmony export IronValidatableBehaviorMeta */
/* harmony export (binding) */i.d(t,"a",(function(){return a}));
/* harmony import */i("pYlh");
/* harmony import */var o=i("1DlD");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Singleton IronMeta instance.
 */
let n=null;
/**
 * `Use IronValidatableBehavior` to implement an element that validates
 * user input. Use the related `IronValidatorBehavior` to add custom
 * validation logic to an iron-input.
 *
 * By default, an `<iron-form>` element validates its fields when the user
 * presses the submit button. To validate a form imperatively, call the form's
 * `validate()` method, which in turn will call `validate()` on all its
 * children. By using `IronValidatableBehavior`, your custom element
 * will get a public `validate()`, which will return the validity of the
 * element, and a corresponding `invalid` attribute, which can be used for
 * styling.
 *
 * To implement the custom validation logic of your element, you must override
 * the protected `_getValidity()` method of this behaviour, rather than
 * `validate()`. See
 * [this](https://github.com/PolymerElements/iron-form/blob/master/demo/simple-element.html)
 * for an example.
 *
 * ### Accessibility
 *
 * Changing the `invalid` property, either manually or by calling `validate()`
 * will update the `aria-invalid` attribute.
 *
 * @demo demo/index.html
 * @polymerBehavior
 */const a={properties:{
/**
     * Name of the validator to use.
     */
validator:{type:String},
/**
     * True if the last call to `validate` is invalid.
     */
invalid:{notify:!0,reflectToAttribute:!0,type:Boolean,value:!1,observer:"_invalidChanged"}},registered:function(){n=new o.a({type:"validator"})},_invalidChanged:function(){this.invalid?this.setAttribute("aria-invalid","true"):this.removeAttribute("aria-invalid")},
/* Recompute this every time it's needed, because we don't know if the
   * underlying IronValidatableBehaviorMeta has changed. */
get _validator(){return n&&n.byKey(this.validator)},
/**
   * @return {boolean} True if the validator `validator` exists.
   */
hasValidator:function(){return null!=this._validator},
/**
   * Returns true if the `value` is valid, and updates `invalid`. If you want
   * your element to have custom validation logic, do not override this method;
   * override `_getValidity(value)` instead.
    * @param {Object} value Deprecated: The value to be validated. By default,
   * it is passed to the validator's `validate()` function, if a validator is
   set.
   * If this argument is not specified, then the element's `value` property
   * is used, if it exists.
   * @return {boolean} True if `value` is valid.
   */
validate:function(e){
// If this is an element that also has a value property, and there was
// no explicit value argument passed, use the element's property instead.
return void 0===e&&void 0!==this.value?this.invalid=!this._getValidity(this.value):this.invalid=!this._getValidity(e),!this.invalid},
/**
   * Returns true if `value` is valid.  By default, it is passed
   * to the validator's `validate()` function, if a validator is set. You
   * should override this method if you want to implement custom validity
   * logic for your element.
   *
   * @param {Object} value The value to be validated.
   * @return {boolean} True if `value` is valid.
   */
_getValidity:function(e){return!this.hasValidator()||this._validator.validate(e)}};
/***/},
/***/EH8K:
/***/function(e,t,i){"use strict";
/* unused harmony export PaperCheckedElementBehaviorImpl */
/* harmony export (binding) */i.d(t,"a",(function(){return r}));
/* harmony import */i("pYlh");
/* harmony import */var o=i("yWrR"),n=i("/VC+"),a=i("n1r2");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * Use `PaperCheckedElementBehavior` to implement a custom element that has a
 * `checked` property similar to `IronCheckedElementBehavior` and is compatible
 * with having a ripple effect.
 * @polymerBehavior PaperCheckedElementBehavior
 */
const s={
/**
   * Synchronizes the element's checked state with its ripple effect.
   */
_checkedChanged:function(){o.b._checkedChanged.call(this),this.hasRipple()&&(this.checked?this._ripple.setAttribute("checked",""):this._ripple.removeAttribute("checked"))},
/**
   * Synchronizes the element's `active` and `checked` state.
   */
_buttonStateChanged:function(){a.a._buttonStateChanged.call(this),this.disabled||this.isAttached&&(this.checked=this.active)}},r=[n.a,o.a,s];
/** @polymerBehavior */},
/***/J9PQ:
/***/function(e,t,i){"use strict";
/* harmony import */i("pYlh"),i("zrEE")
/* harmony import */;var o=i("EH8K"),n=i("/VC+"),a=i("qEMp"),s=i("o5Wi"),r=i("7BTU");
/**
@license
Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at http://polymer.github.io/LICENSE.txt
The complete set of authors may be found at http://polymer.github.io/AUTHORS.txt
The complete set of contributors may be found at http://polymer.github.io/CONTRIBUTORS.txt
Code distributed by Google as part of the polymer project is also
subject to an additional IP rights grant found at http://polymer.github.io/PATENTS.txt
*/
const l=s.a`<style>:host{display:inline-block;white-space:nowrap;cursor:pointer;--calculated-paper-checkbox-size:var(--paper-checkbox-size, 18px);--calculated-paper-checkbox-ink-size:var(--paper-checkbox-ink-size, -1px);@apply --paper-font-common-base;line-height:0;-webkit-tap-highlight-color:transparent}:host([hidden]){display:none!important}:host(:focus){outline:0}.hidden{display:none}#checkboxContainer{display:inline-block;position:relative;width:var(--calculated-paper-checkbox-size);height:var(--calculated-paper-checkbox-size);min-width:var(--calculated-paper-checkbox-size);margin:var(--paper-checkbox-margin,initial);vertical-align:var(--paper-checkbox-vertical-align,middle);background-color:var(--paper-checkbox-unchecked-background-color,transparent)}#ink{position:absolute;top:calc(0px - (var(--calculated-paper-checkbox-ink-size) - var(--calculated-paper-checkbox-size))/ 2);left:calc(0px - (var(--calculated-paper-checkbox-ink-size) - var(--calculated-paper-checkbox-size))/ 2);width:var(--calculated-paper-checkbox-ink-size);height:var(--calculated-paper-checkbox-ink-size);color:var(--paper-checkbox-unchecked-ink-color,var(--primary-text-color));opacity:.6;pointer-events:none}#ink:dir(rtl){right:calc(0px - (var(--calculated-paper-checkbox-ink-size) - var(--calculated-paper-checkbox-size))/ 2);left:auto}#ink[checked]{color:var(--paper-checkbox-checked-ink-color,var(--primary-color))}#checkbox{position:relative;box-sizing:border-box;height:100%;border:solid 2px;border-color:var(--paper-checkbox-unchecked-color,var(--primary-text-color));border-radius:2px;pointer-events:none;-webkit-transition:background-color 140ms,border-color 140ms;transition:background-color 140ms,border-color 140ms;-webkit-transition-duration:var(--paper-checkbox-animation-duration,140ms);transition-duration:var(--paper-checkbox-animation-duration,140ms)}#checkbox.checked #checkmark{-webkit-animation:checkmark-expand 140ms ease-out forwards;animation:checkmark-expand 140ms ease-out forwards;-webkit-animation-duration:var(--paper-checkbox-animation-duration,140ms);animation-duration:var(--paper-checkbox-animation-duration,140ms)}@-webkit-keyframes checkmark-expand{0%{-webkit-transform:scale(0,0) rotate(45deg)}100%{-webkit-transform:scale(1,1) rotate(45deg)}}@keyframes checkmark-expand{0%{transform:scale(0,0) rotate(45deg)}100%{transform:scale(1,1) rotate(45deg)}}#checkbox.checked{background-color:var(--paper-checkbox-checked-color,var(--primary-color));border-color:var(--paper-checkbox-checked-color,var(--primary-color))}#checkmark{position:absolute;width:36%;height:70%;border-style:solid;border-top:none;border-left:none;border-right-width:calc(2/15 * var(--calculated-paper-checkbox-size));border-bottom-width:calc(2/15 * var(--calculated-paper-checkbox-size));border-color:var(--paper-checkbox-checkmark-color,#fff);-webkit-transform-origin:97% 86%;transform-origin:97% 86%;box-sizing:content-box}#checkmark:dir(rtl){-webkit-transform-origin:50% 14%;transform-origin:50% 14%}#checkboxLabel{position:relative;display:inline-block;vertical-align:middle;padding-left:var(--paper-checkbox-label-spacing,8px);white-space:normal;line-height:normal;color:var(--paper-checkbox-label-color,var(--primary-text-color));@apply --paper-checkbox-label;}:host([checked]) #checkboxLabel{color:var(--paper-checkbox-label-checked-color,var(--paper-checkbox-label-color,var(--primary-text-color)));@apply --paper-checkbox-label-checked;}#checkboxLabel:dir(rtl){padding-right:var(--paper-checkbox-label-spacing,8px);padding-left:0}#checkboxLabel[hidden]{display:none}:host([disabled]) #checkbox{opacity:.5;border-color:var(--paper-checkbox-unchecked-color,var(--primary-text-color))}:host([disabled][checked]) #checkbox{background-color:var(--paper-checkbox-unchecked-color,var(--primary-text-color));opacity:.5}:host([disabled]) #checkboxLabel{opacity:.65}#checkbox.invalid:not(.checked){border-color:var(--paper-checkbox-error-color,var(--error-color))}</style><div id="checkboxContainer"><div id="checkbox" class$="[[_computeCheckboxClass(checked, invalid)]]"><div id="checkmark" class$="[[_computeCheckmarkClass(checked)]]"></div></div></div><div id="checkboxLabel"><slot></slot></div>`;l.setAttribute("strip-whitespace",""),
/**
Material design:
[Checkbox](https://www.google.com/design/spec/components/selection-controls.html#selection-controls-checkbox)

`paper-checkbox` is a button that can be either checked or unchecked. User can
tap the checkbox to check or uncheck it. Usually you use checkboxes to allow
user to select multiple options from a set. If you have a single ON/OFF option,
avoid using a single checkbox and use `paper-toggle-button` instead.

Example:

    <paper-checkbox>label</paper-checkbox>

    <paper-checkbox checked> label</paper-checkbox>

### Styling

The following custom properties and mixins are available for styling:

Custom property | Description | Default
----------------|-------------|----------
`--paper-checkbox-unchecked-background-color` | Checkbox background color when the input is not checked | `transparent`
`--paper-checkbox-unchecked-color` | Checkbox border color when the input is not checked | `--primary-text-color`
`--paper-checkbox-unchecked-ink-color` | Selected/focus ripple color when the input is not checked | `--primary-text-color`
`--paper-checkbox-checked-color` | Checkbox color when the input is checked | `--primary-color`
`--paper-checkbox-checked-ink-color` | Selected/focus ripple color when the input is checked | `--primary-color`
`--paper-checkbox-checkmark-color` | Checkmark color | `white`
`--paper-checkbox-label-color` | Label color | `--primary-text-color`
`--paper-checkbox-label-checked-color` | Label color when the input is checked | `--paper-checkbox-label-color`
`--paper-checkbox-label-spacing` | Spacing between the label and the checkbox | `8px`
`--paper-checkbox-label` | Mixin applied to the label | `{}`
`--paper-checkbox-label-checked` | Mixin applied to the label when the input is checked | `{}`
`--paper-checkbox-error-color` | Checkbox color when invalid | `--error-color`
`--paper-checkbox-size` | Size of the checkbox | `18px`
`--paper-checkbox-ink-size` | Size of the ripple | `48px`
`--paper-checkbox-margin` | Margin around the checkbox container | `initial`
`--paper-checkbox-vertical-align` | Vertical alignment of the checkbox container | `middle`

This element applies the mixin `--paper-font-common-base` but does not import
`paper-styles/typography.html`. In order to apply the `Roboto` font to this
element, make sure you've imported `paper-styles/typography.html`.

@demo demo/index.html
*/
Object(a.a)({_template:l,is:"paper-checkbox",behaviors:[o.a],
/** @private */
hostAttributes:{role:"checkbox","aria-checked":!1,tabindex:0},properties:{
/**
     * Fired when the checked state changes due to user interaction.
     *
     * @event change
     */
/**
     * Fired when the checked state changes.
     *
     * @event iron-change
     */
ariaActiveAttribute:{type:String,value:"aria-checked"}},attached:function(){
// Wait until styles have resolved to check for the default sentinel.
// See polymer#4009 for more details.
Object(r.a)(this,(function(){// If unset, compute and set the default `--paper-checkbox-ink-size`.
if("-1px"===this.getComputedStyleValue("--calculated-paper-checkbox-ink-size").trim()){var e=this.getComputedStyleValue("--calculated-paper-checkbox-size").trim(),t="px",i=e.match(/[A-Za-z]+$/);null!==i&&(t=i[0]);var o=parseFloat(e),n=8/3*o;"px"===t&&(n=Math.floor(n))%2!=o%2&&n++,this.updateStyles({"--paper-checkbox-ink-size":n+t})}}))},_computeCheckboxClass:function(e,t){var i="";return e&&(i+="checked "),t&&(i+="invalid"),i},_computeCheckmarkClass:function(e){return e?"":"hidden"},
// create ripple inside the checkboxContainer
_createRipple:function(){return this._rippleContainer=this.$.checkboxContainer,n.b._createRipple.call(this)}})},
/***/JxY1:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return s}));
/* harmony import */i("pYlh");
/* harmony import */var o=i("hvZu"),n=i("H/aU"),a=new Set;
/**
 * `IronResizableBehavior` is a behavior that can be used in Polymer elements to
 * coordinate the flow of resize events between "resizers" (elements that
 *control the size or hidden state of their children) and "resizables" (elements
 *that need to be notified when they are resized or un-hidden by their parents
 *in order to take action on their new measurements).
 *
 * Elements that perform measurement should add the `IronResizableBehavior`
 *behavior to their element definition and listen for the `iron-resize` event on
 *themselves. This event will be fired when they become showing after having
 *been hidden, when they are resized explicitly by another resizable, or when
 *the window has been resized.
 *
 * Note, the `iron-resize` event is non-bubbling.
 *
 * @polymerBehavior
 * @demo demo/index.html
 **/
const s={properties:{
/**
     * The closest ancestor element that implements `IronResizableBehavior`.
     */
_parentResizable:{type:Object,observer:"_parentResizableChanged"},
/**
     * True if this element is currently notifying its descendant elements of
     * resize.
     */
_notifyingDescendant:{type:Boolean,value:!1}},listeners:{"iron-request-resize-notifications":"_onIronRequestResizeNotifications"},created:function(){
// We don't really need property effects on these, and also we want them
// to be created before the `_parentResizable` observer fires:
this._interestedResizables=[],this._boundNotifyResize=this.notifyResize.bind(this),this._boundOnDescendantIronResize=this._onDescendantIronResize.bind(this)},attached:function(){this._requestResizeNotifications()},detached:function(){this._parentResizable?this._parentResizable.stopResizeNotificationsFor(this):(a.delete(this),window.removeEventListener("resize",this._boundNotifyResize)),this._parentResizable=null},
/**
   * Can be called to manually notify a resizable and its descendant
   * resizables of a resize change.
   */
notifyResize:function(){this.isAttached&&(this._interestedResizables.forEach((function(e){this.resizerShouldNotify(e)&&this._notifyDescendant(e)}),this),this._fireResize())},
/**
   * Used to assign the closest resizable ancestor to this resizable
   * if the ancestor detects a request for notifications.
   */
assignParentResizable:function(e){this._parentResizable&&this._parentResizable.stopResizeNotificationsFor(this),this._parentResizable=e,e&&-1===e._interestedResizables.indexOf(this)&&(e._interestedResizables.push(this),e._subscribeIronResize(this))},
/**
   * Used to remove a resizable descendant from the list of descendants
   * that should be notified of a resize change.
   */
stopResizeNotificationsFor:function(e){var t=this._interestedResizables.indexOf(e);t>-1&&(this._interestedResizables.splice(t,1),this._unsubscribeIronResize(e))},
/**
   * Subscribe this element to listen to iron-resize events on the given target.
   *
   * Preferred over target.listen because the property renamer does not
   * understand to rename when the target is not specifically "this"
   *
   * @param {!HTMLElement} target Element to listen to for iron-resize events.
   */
_subscribeIronResize:function(e){e.addEventListener("iron-resize",this._boundOnDescendantIronResize)},
/**
   * Unsubscribe this element from listening to to iron-resize events on the
   * given target.
   *
   * Preferred over target.unlisten because the property renamer does not
   * understand to rename when the target is not specifically "this"
   *
   * @param {!HTMLElement} target Element to listen to for iron-resize events.
   */
_unsubscribeIronResize:function(e){e.removeEventListener("iron-resize",this._boundOnDescendantIronResize)},
/**
   * This method can be overridden to filter nested elements that should or
   * should not be notified by the current element. Return true if an element
   * should be notified, or false if it should not be notified.
   *
   * @param {HTMLElement} element A candidate descendant element that
   * implements `IronResizableBehavior`.
   * @return {boolean} True if the `element` should be notified of resize.
   */
resizerShouldNotify:function(e){return!0},_onDescendantIronResize:function(e){this._notifyingDescendant?e.stopPropagation():// no need to use this during shadow dom because of event retargeting
n.s||this._fireResize()},_fireResize:function(){this.fire("iron-resize",null,{node:this,bubbles:!1})},_onIronRequestResizeNotifications:function(e){var t=
/** @type {!EventTarget} */
Object(o.a)(e).rootTarget;t!==this&&(t.assignParentResizable(this),this._notifyDescendant(t),e.stopPropagation())},_parentResizableChanged:function(e){e&&window.removeEventListener("resize",this._boundNotifyResize)},_notifyDescendant:function(e){
// NOTE(cdata): In IE10, attached is fired on children first, so it's
// important not to notify them if the parent is not attached yet (or
// else they will get redundantly notified when the parent attaches).
this.isAttached&&(this._notifyingDescendant=!0,e.notifyResize(),this._notifyingDescendant=!1)},_requestResizeNotifications:function(){if(this.isAttached)if("loading"===document.readyState){var e=this._requestResizeNotifications.bind(this);document.addEventListener("readystatechange",(function t(){document.removeEventListener("readystatechange",t),e()}))}else this._findParent(),this._parentResizable?
// If this resizable has a parent, tell other child resizables of
// that parent to try finding their parent again, in case it's this
// resizable.
this._parentResizable._interestedResizables.forEach((function(e){e!==this&&e._findParent()}),this):(
// If this resizable is an orphan, tell other orphans to try to find
// their parent again, in case it's this resizable.
a.forEach((function(e){e!==this&&e._findParent()}),this),window.addEventListener("resize",this._boundNotifyResize),this.notifyResize())},_findParent:function(){this.assignParentResizable(null),this.fire("iron-request-resize-notifications",null,{node:this,bubbles:!0,cancelable:!0}),this._parentResizable?a.delete(this):a.add(this)}};
/***/},
/***/n1r2:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return a}));
/* harmony import */i("pYlh"),i("iwXV")
/* harmony import */;var o=i("G2f5"),n=i("hvZu");
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * `PaperRippleBehavior` dynamically implements a ripple when the element has
 * focus via pointer or keyboard.
 *
 * NOTE: This behavior is intended to be used in conjunction with and after
 * `IronButtonState` and `IronControlState`.
 *
 * @polymerBehavior PaperRippleBehavior
 */
const a={properties:{
/**
     * If true, the element will not produce a ripple effect when interacted
     * with via the pointer.
     */
noink:{type:Boolean,observer:"_noinkChanged"},
/**
     * @type {Element|undefined}
     */
_rippleContainer:{type:Object}},
/**
   * Ensures a `<paper-ripple>` element is available when the element is
   * focused.
   */
_buttonStateChanged:function(){this.focused&&this.ensureRipple()},
/**
   * In addition to the functionality provided in `IronButtonState`, ensures
   * a ripple effect is created when the element is in a `pressed` state.
   */
_downHandler:function(e){o.b._downHandler.call(this,e),this.pressed&&this.ensureRipple(e)},
/**
   * Ensures this element contains a ripple effect. For startup efficiency
   * the ripple effect is dynamically on demand when needed.
   * @param {!Event=} optTriggeringEvent (optional) event that triggered the
   * ripple.
   */
ensureRipple:function(e){if(!this.hasRipple()){this._ripple=this._createRipple(),this._ripple.noink=this.noink;var t=this._rippleContainer||this.root;if(t&&Object(n.a)(t).appendChild(this._ripple),e){
// Check if the event happened inside of the ripple container
// Fall back to host instead of the root because distributed text
// nodes are not valid event targets
var i=Object(n.a)(this._rippleContainer||this),o=Object(n.a)(e).rootTarget;i.deepContains(
/** @type {Node} */
o)&&this._ripple.uiDownAction(e)}}},
/**
   * Returns the `<paper-ripple>` element used by this element to create
   * ripple effects. The element's ripple is created on demand, when
   * necessary, and calling this method will force the
   * ripple to be created.
   */
getRipple:function(){return this.ensureRipple(),this._ripple},
/**
   * Returns true if this element currently contains a ripple effect.
   * @return {boolean}
   */
hasRipple:function(){return Boolean(this._ripple)},
/**
   * Create the element's ripple effect via creating a `<paper-ripple>`.
   * Override this method to customize the ripple element.
   * @return {!PaperRippleElement} Returns a `<paper-ripple>` element.
   */
_createRipple:function(){
/** @type {!PaperRippleElement} */
return document.createElement("paper-ripple")},_noinkChanged:function(e){this.hasRipple()&&(this._ripple.noink=e)}};
/***/},
/***/ooBa:
/***/function(e,t,i){"use strict";
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/polymer-legacy.js?babel-target=es6
i("pYlh"),i("1Ohj"),i("KR5w"),i("DOh8"),i("WnqL"),i("zrEE");
// EXTERNAL MODULE: ./node_modules/@polymer/iron-flex-layout/iron-flex-layout.js?babel-target=es6
var o=i("G2f5"),n=i("Z+yT"),a=i("n1r2");
// CONCATENATED MODULE: ./node_modules/@polymer/paper-behaviors/paper-button-behavior.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/** @polymerBehavior PaperButtonBehavior */
const s={properties:{
/**
     * The z-depth of this element, from 0-5. Setting to 0 will remove the
     * shadow, and each increasing number greater than 0 will be "deeper"
     * than the last.
     *
     * @attribute elevation
     * @type number
     * @default 1
     */
elevation:{type:Number,reflectToAttribute:!0,readOnly:!0}},observers:["_calculateElevation(focused, disabled, active, pressed, receivedFocusFromKeyboard)","_computeKeyboardClass(receivedFocusFromKeyboard)"],hostAttributes:{role:"button",tabindex:"0",animated:!0},_calculateElevation:function(){var e=1;this.disabled?e=0:this.active||this.pressed?e=4:this.receivedFocusFromKeyboard&&(e=3),this._setElevation(e)},_computeKeyboardClass:function(e){this.toggleClass("keyboard-focus",e)},
/**
   * In addition to `IronButtonState` behavior, when space key goes down,
   * create a ripple down effect.
   *
   * @param {!KeyboardEvent} event .
   */
_spaceKeyDownHandler:function(e){o.b._spaceKeyDownHandler.call(this,e),// Ensure that there is at most one ripple when the space key is held down.
this.hasRipple()&&this.getRipple().ripples.length<1&&this._ripple.uiDownAction()},
/**
   * In addition to `IronButtonState` behavior, when space key goes up,
   * create a ripple up effect.
   *
   * @param {!KeyboardEvent} event .
   */
_spaceKeyUpHandler:function(e){o.b._spaceKeyUpHandler.call(this,e),this.hasRipple()&&this._ripple.uiUpAction()}},r=[o.a,n.a,a.a,s];
/** @polymerBehavior */
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/legacy/polymer-fn.js?babel-target=es6
var l=i("qEMp");
// EXTERNAL MODULE: ./node_modules/@polymer/polymer/lib/utils/html-tag.js?babel-target=es6
// CONCATENATED MODULE: ./node_modules/@polymer/paper-fab/paper-fab.js?babel-target=es6
/**
@license
Copyright (c) 2015 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
const c=i("o5Wi").a`<style include="paper-material-styles">:host{@apply --layout-vertical;@apply --layout-center-center;background:var(--paper-fab-background,var(--accent-color));border-radius:50%;box-sizing:border-box;color:var(--text-primary-color);cursor:pointer;height:56px;min-width:0;outline:0;padding:16px;position:relative;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;user-select:none;width:56px;z-index:0;-webkit-tap-highlight-color:transparent;-webkit-tap-highlight-color:transparent;@apply --paper-fab;}[hidden]{display:none!important}:host([mini]){width:40px;height:40px;padding:8px;@apply --paper-fab-mini;}:host([disabled]){color:var(--paper-fab-disabled-text,var(--paper-grey-500));background:var(--paper-fab-disabled-background,var(--paper-grey-300));@apply --paper-fab-disabled;}iron-icon{@apply --paper-fab-iron-icon;}span{width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;@apply --paper-fab-label;}:host(.keyboard-focus){background:var(--paper-fab-keyboard-focus-background,var(--paper-pink-900))}:host([elevation="1"]){@apply --paper-material-elevation-1;}:host([elevation="2"]){@apply --paper-material-elevation-2;}:host([elevation="3"]){@apply --paper-material-elevation-3;}:host([elevation="4"]){@apply --paper-material-elevation-4;}:host([elevation="5"]){@apply --paper-material-elevation-5;}</style><iron-icon id="icon" hidden\$="{{!_computeIsIconFab(icon, src)}}" src="[[src]]" icon="[[icon]]"></iron-icon><span hidden\$="{{_computeIsIconFab(icon, src)}}">{{label}}</span>`;c.setAttribute("strip-whitespace",""),
/**
Material design: [Floating Action
Button](https://www.google.com/design/spec/components/buttons-floating-action-button.html)

`paper-fab` is a floating action button. It contains an image placed in the
center and comes in two sizes: regular size and a smaller size by applying the
attribute `mini`. When the user touches the button, a ripple effect emanates
from the center of the button.

You may import `iron-icons` to use with this element, or provide a URL to a
custom icon. See `iron-iconset` for more information about how to use a custom
icon set.

Example:

    <script type="module">
      import '@polymer/iron-icons/iron-icons.js';
    <\/script>

    <paper-fab icon="add"></paper-fab>
    <paper-fab mini icon="favorite"></paper-fab>
    <paper-fab src="star.png"></paper-fab>


### Styling

The following custom properties and mixins are available for styling:

Custom property | Description | Default
----------------|-------------|----------
`--paper-fab-background` | The background color of the button | `--accent-color`
`--paper-fab-keyboard-focus-background` | The background color of the button when focused | `--paper-pink-900`
`--paper-fab-disabled-background` | The background color of the button when it's disabled | `--paper-grey-300`
`--paper-fab-disabled-text` | The text color of the button when it's disabled | `--paper-grey-500`
`--paper-fab` | Mixin applied to the button | `{}`
`--paper-fab-mini` | Mixin applied to a mini button | `{}`
`--paper-fab-disabled` | Mixin applied to a disabled button | `{}`
`--paper-fab-iron-icon` | Mixin applied to the iron-icon within the button | `{}`
`--paper-fab-label` | Mixin applied to the label within the button | `{}`

@group Paper Elements
@demo demo/index.html
*/
Object(l.a)({_template:c,is:"paper-fab",behaviors:[r],properties:{
/**
     * The URL of an image for the icon. If the src property is specified,
     * the icon property should not be.
     */
src:{type:String,value:""},
/**
     * Specifies the icon name or index in the set of icons available in
     * the icon's icon set. If the icon property is specified,
     * the src property should not be.
     */
icon:{type:String,value:""},
/**
     * Set this to true to style this is a "mini" FAB.
     */
mini:{type:Boolean,value:!1,reflectToAttribute:!0},
/**
     * The label displayed in the badge. The label is centered, and ideally
     * should have very few characters.
     */
label:{type:String,observer:"_labelChanged"}},_labelChanged:function(){this.setAttribute("aria-label",this.label)},_computeIsIconFab:function(e,t){return e.length>0||t.length>0}})},
/***/uo8t:
/***/function(e,t,i){"use strict";
/* harmony export (binding) */i.d(t,"a",(function(){return n}));
/* harmony import */i("pYlh");
/* harmony import */var o=i("hvZu");
/**
@license
Copyright (c) 2016 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/
/**
 * `Polymer.IronScrollTargetBehavior` allows an element to respond to scroll
 * events from a designated scroll target.
 *
 * Elements that consume this behavior can override the `_scrollHandler`
 * method to add logic on the scroll event.
 *
 * @demo demo/scrolling-region.html Scrolling Region
 * @demo demo/document.html Document Element
 * @polymerBehavior
 */
const n={properties:{
/**
     * Specifies the element that will handle the scroll event
     * on the behalf of the current element. This is typically a reference to an
     *element, but there are a few more posibilities:
     *
     * ### Elements id
     *
     *```html
     * <div id="scrollable-element" style="overflow: auto;">
     *  <x-element scroll-target="scrollable-element">
     *    <!-- Content-->
     *  </x-element>
     * </div>
     *```
     * In this case, the `scrollTarget` will point to the outer div element.
     *
     * ### Document scrolling
     *
     * For document scrolling, you can use the reserved word `document`:
     *
     *```html
     * <x-element scroll-target="document">
     *   <!-- Content -->
     * </x-element>
     *```
     *
     * ### Elements reference
     *
     *```js
     * appHeader.scrollTarget = document.querySelector('#scrollable-element');
     *```
     *
     * @type {HTMLElement}
     * @default document
     */
scrollTarget:{type:HTMLElement,value:function(){return this._defaultScrollTarget}}},observers:["_scrollTargetChanged(scrollTarget, isAttached)"],
/**
   * True if the event listener should be installed.
   */
_shouldHaveListener:!0,_scrollTargetChanged:function(e,t){if(this._oldScrollTarget&&(this._toggleScrollListener(!1,this._oldScrollTarget),this._oldScrollTarget=null),t)// Support element id references
if("document"===e)this.scrollTarget=this._doc;else if("string"==typeof e){var i=this.domHost;this.scrollTarget=i&&i.$?i.$[e]:Object(o.a)(this.ownerDocument).querySelector("#"+e)}else this._isValidScrollTarget()&&(this._oldScrollTarget=e,this._toggleScrollListener(this._shouldHaveListener,e))},
/**
   * Runs on every scroll event. Consumer of this behavior may override this
   * method.
   *
   * @protected
   */
_scrollHandler:function(){},
/**
   * The default scroll target. Consumers of this behavior may want to customize
   * the default scroll target.
   *
   * @type {Element}
   */
get _defaultScrollTarget(){return this._doc},
/**
   * Shortcut for the document element
   *
   * @type {Element}
   */
get _doc(){return this.ownerDocument.documentElement},
/**
   * Gets the number of pixels that the content of an element is scrolled
   * upward.
   *
   * @type {number}
   */
get _scrollTop(){return this._isValidScrollTarget()?this.scrollTarget===this._doc?window.pageYOffset:this.scrollTarget.scrollTop:0},
/**
   * Gets the number of pixels that the content of an element is scrolled to the
   * left.
   *
   * @type {number}
   */
get _scrollLeft(){return this._isValidScrollTarget()?this.scrollTarget===this._doc?window.pageXOffset:this.scrollTarget.scrollLeft:0},
/**
   * Sets the number of pixels that the content of an element is scrolled
   * upward.
   *
   * @type {number}
   */
set _scrollTop(e){this.scrollTarget===this._doc?window.scrollTo(window.pageXOffset,e):this._isValidScrollTarget()&&(this.scrollTarget.scrollTop=e)},
/**
   * Sets the number of pixels that the content of an element is scrolled to the
   * left.
   *
   * @type {number}
   */
set _scrollLeft(e){this.scrollTarget===this._doc?window.scrollTo(e,window.pageYOffset):this._isValidScrollTarget()&&(this.scrollTarget.scrollLeft=e)},
/**
   * Scrolls the content to a particular place.
   *
   * @method scroll
   * @param {number|!{left: number, top: number}} leftOrOptions The left position or scroll options
   * @param {number=} top The top position
   * @return {void}
   */
scroll:function(e,t){var i;"object"==typeof e?(i=e.left,t=e.top):i=e,i=i||0,t=t||0,this.scrollTarget===this._doc?window.scrollTo(i,t):this._isValidScrollTarget()&&(this.scrollTarget.scrollLeft=i,this.scrollTarget.scrollTop=t)},
/**
   * Gets the width of the scroll target.
   *
   * @type {number}
   */
get _scrollTargetWidth(){return this._isValidScrollTarget()?this.scrollTarget===this._doc?window.innerWidth:this.scrollTarget.offsetWidth:0},
/**
   * Gets the height of the scroll target.
   *
   * @type {number}
   */
get _scrollTargetHeight(){return this._isValidScrollTarget()?this.scrollTarget===this._doc?window.innerHeight:this.scrollTarget.offsetHeight:0},
/**
   * Returns true if the scroll target is a valid HTMLElement.
   *
   * @return {boolean}
   */
_isValidScrollTarget:function(){return this.scrollTarget instanceof HTMLElement},_toggleScrollListener:function(e,t){var i=t===this._doc?window:t;e?this._boundScrollHandler||(this._boundScrollHandler=this._scrollHandler.bind(this),i.addEventListener("scroll",this._boundScrollHandler)):this._boundScrollHandler&&(i.removeEventListener("scroll",this._boundScrollHandler),this._boundScrollHandler=null)},
/**
   * Enables or disables the scroll event listener.
   *
   * @param {boolean} yes True to add the event, False to remove it.
   */
toggleScrollListener:function(e){this._shouldHaveListener=e,this._toggleScrollListener(e,this.scrollTarget)}};
/***/}}]);